import React from "react";

import { Icon, IconBox, Tooltip } from "@proda-ai/ui-kit";

import Box from "@/ui/atoms/Box";
import type { BoxProps } from "@/ui/atoms/Box";

import type { IHeaderParams } from "@/ui/molecules/Grid";

export const testIds = {
    main: "GridChildrenHeaderComponent",
    selected: "GridChildrenHeaderComponent-selected",
};
export const GridChildrenHeaderComponent = (
    props: BoxProps &
        IHeaderParams & {
            selected: boolean;
            tooltipContent: React.ReactNode;
            redirect?: () => void;
            url?: string;
            groupHeaderName: string;
        },
) => {
    const {
        tooltipContent,
        displayName,
        selected,
        url,
        redirect,
        sx,
        groupHeaderName,
    } = props;

    const handleHeaderClicked = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        if (url !== undefined) {
            window.open(url, "_blank");
        } else {
            redirect?.();
        }
    };

    return (
        <Tooltip
            content={tooltipContent}
            style={{
                width: "100%",
                height: "100%",
            }}
        >
            <Box
                data-testid={testIds.main}
                data-group-header-name={groupHeaderName}
                sx={{
                    color: "var(--text-color-dark) !important",
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    height: "100%",
                    backgroundColor: selected
                        ? "var(--proda-white)"
                        : "var(--proda-white-110)",
                    padding: "0px 12px",
                    ...sx,
                }}
            >
                <a
                    href={url}
                    onClick={handleHeaderClicked}
                    draggable={false}
                    style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                    }}
                >
                    {selected && (
                        <Box
                            data-testid={testIds.selected}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                backgroundColor: "var(--proda-neon-blue)",
                                color: "white",
                                marginRight: "0.5rem",
                                fontWeight: "bold",
                                flexShrink: 0,
                            }}
                        >
                            <IconBox>
                                <Icon icon="check" size="2xs" />
                            </IconBox>
                        </Box>
                    )}
                    <Box
                        sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            flexGrow: 1,
                        }}
                    >
                        {displayName}
                    </Box>
                </a>
            </Box>
        </Tooltip>
    );
};

export default GridChildrenHeaderComponent;
